<!DOCTYPE html>
<html lang="en">

<head>
  <meta charset="utf-8">
  <meta content="width=device-width, initial-scale=1.0" name="viewport">
  <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no">

  <title>Don Emilio Construcciones</title>
  <meta content="" name="descriptison">
  <meta content="" name="keywords">

  <!-- Favicons -->
  <link href="assets/img/favicon.png" rel="icon">
  <link href="assets/img/apple-touch-icon.png" rel="apple-touch-icon">

  <!-- Google Fonts -->
  <link href="https://fonts.googleapis.com/css?family=Open+Sans:300,300i,400,400i,600,600i,700,700i|Raleway:300,300i,400,400i,600,600i,700,700i" rel="stylesheet">

  <!-- Vendor CSS Files -->
  <script src="https://kit.fontawesome.com/fe7b457cf8.js" crossorigin="anonymous"></script>
  <script src="https://unpkg.com/boxicons@latest/dist/boxicons.js"></script>
  <link href='https://unpkg.com/boxicons@2.0.5/css/boxicons.min.css' rel='stylesheet'>
  <link href="https://cdnjs.cloudflare.com/ajax/libs/venobox/1.8.6/venobox.min.js" rel="stylesheet">
  <link href="https://cdnjs.cloudflare.com/ajax/libs/OwlCarousel2/2.3.4/owl.carousel.min.js" rel="stylesheet">
  <link href="https://cdnjs.cloudflare.com/ajax/libs/aos/2.3.4/aos.js" rel="stylesheet">

  <!-- <link rel="stylesheet" href="assets/css/style.css"> -->

</head>

<body>

  <nav class="navbar navbar-expand-lg navbar-light bg-light">
    <a class="navbar-brand" [routerLink]="['home']">
      <img src="../assets/img/esquina.jpg" width="50" height="30" class="d-inline-block align-top" alt="">
    </a>
    <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>

    <div class="collapse navbar-collapse" id="navbarSupportedContent">
      <ul class="navbar-nav ml-auto">
        <li class="nav-item" routerLinkActive="active">
          <a class="nav-item nav-link" [routerLink]="['home']">Inicio</a>
        </li>
        <li class="nav-item" routerLinkActive="active">
          <a class="nav-item nav-link" [routerLink]="['about']">Acerca de nosotros</a>
        </li>
        <li class="nav-item" routerLinkActive="active">
          <a class="nav-item nav-link" [routerLink]="['services']">Lotes en venta</a>
        </li>
        <li class="nav-item" routerLinkActive="active">
          <a class="nav-item nav-link" [routerLink]="['contact']">Contacto</a>
        </li>
      </ul>
    </div>
  </nav>

  <router-outlet></router-outlet>

  <!-- ======= Footer ======= -->
  <hr>
  <footer id="footer">

    <div class="footer-top">
      <div class="container">
        <div class="row ">

          <div class="col-lg-3 col-md-6 footer-contact" data-aos="fade-up" data-aos-delay="100">
            <h3>Don Emilio Construcciones</h3>
            <p>
              <br>
              <strong>Teléfonos:</strong> +34 656 90 43 26 / <br> + 549 264 541 5848<br>
              <br>
              <strong>Email:</strong> donemilioconstrucciones@gmail.com<br>
              <br>
              <strong>Dirección:</strong> Calle Vidart S 4975, Villa Krause, San Juan<br>
            </p>
          </div>

          <div class="col-lg-3 col-md-6 footer-links" data-aos="fade-up" data-aos-delay="200">
            <h4>Links útiles</h4>
            <ul>
              <li><i class="bx bx-chevron-right"></i> <a [routerLink]="['home']">Inicio</a></li>
              <li><i class="bx bx-chevron-right"></i> <a [routerLink]="['about']">Acerca de nosotros</a></li>
              <li><i class="bx bx-chevron-right"></i> <a [routerLink]="['contact']">Contacto</a></li>
            </ul>
          </div>

          <div class="col-lg-3 col-md-6 footer-links" data-aos="fade-up" data-aos-delay="300">
            <h4>Nuestros Servicios</h4>
            <ul>
              <li><i class="bx bx-chevron-right"></i> <a [routerLink]="['services']">Lotes</a></li>
            </ul>
          </div>

          <div class="col-lg-3 col-md-6 footer-links" data-aos="fade-up" data-aos-delay="400">
            <h4>Nuestras redes sociales</h4>
            <p>Conozca mas sobre nosotros en nuestras redes.</p>
            <div class="social-links mt-3">
              <a href="https://www.facebook.com/emilio.demiguel.925" class="facebook"><i class="bx bxl-facebook"></i></a>
            </div>
          </div>

        </div>
      </div>
    </div>

    <div class="container py-4">
      <div class="copyright">
        &copy; Copyright <strong><span>Don Emilio Construcciones</span></strong>. Todos los derechos reservados
      </div>
    </div>
  </footer><!-- End Footer -->


  <!-- Vendor JS Files -->
  <script src="assets/vendor/jquery/jquery.min.js"></script>
  <script src="assets/vendor/bootstrap/js/bootstrap.bundle.min.js"></script>
  <script src="assets/vendor/jquery.easing/jquery.easing.min.js"></script>
  <script src="assets/vendor/php-email-form/validate.js"></script>
  <script src="assets/vendor/isotope-layout/isotope.pkgd.min.js"></script>
  <script src="assets/vendor/venobox/venobox.min.js"></script>
  <script src="assets/vendor/owl.carousel/owl.carousel.min.js"></script>
  <script src="assets/vendor/aos/aos.js"></script>

  <!-- Template Main JS File -->
  <script src="assets/js/main.js"></script>

</body>

</html>
